// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XifinDocumentUpload-module__font-s-10___NXsrk {
  font-size: 10px !important;
}

.XifinDocumentUpload-module__font-s-12___mZhgs {
  font-size: 12px !important;
}

.XifinDocumentUpload-module__font-s-13___OBKMh {
  font-size: 13px !important;
}

.XifinDocumentUpload-module__font-s-14___ueU7N {
  font-size: 14px !important;
}

.XifinDocumentUpload-module__font-s-15___vzhrk {
  font-size: 15px !important;
}

.XifinDocumentUpload-module__font-s-16___zQdke {
  font-size: 16px !important;
}

.XifinDocumentUpload-module__font-s-18___fINEU {
  font-size: 18px !important;
}

.XifinDocumentUpload-module__font-s-20___tu3qj {
  font-size: 20px !important;
}

.XifinDocumentUpload-module__font-s-22___LqndE {
  font-size: 22px !important;
}

.XifinDocumentUpload-module__font-s-28___aiuKn {
  font-size: 28px !important;
}

.XifinDocumentUpload-module__font-w-400___morsZ {
  font-weight: 400 !important;
}

.XifinDocumentUpload-module__font-w-500___dfIsp {
  font-weight: 500 !important;
}

.XifinDocumentUpload-module__font-w-600___WLgcv {
  font-weight: 600 !important;
}

.XifinDocumentUpload-module__font-w-700___IMg0K {
  font-weight: 700 !important;
}

.XifinDocumentUpload-module__p-5___e1oGw {
  padding: 5px !important;
}

.XifinDocumentUpload-module__p-12___kHqtY {
  padding: 12px !important;
}

.XifinDocumentUpload-module__p-16___vasjI {
  padding: 16px !important;
}

.XifinDocumentUpload-module__p-30___JuV1f {
  padding: 30px !important;
}

.XifinDocumentUpload-module__p-b-0___BHN1E {
  padding-bottom: 0 !important;
}

.XifinDocumentUpload-module__p-b-5___HJod2 {
  padding-bottom: 5px !important;
}

.XifinDocumentUpload-module__p-b-10___RwDoL {
  padding-bottom: 10px !important;
}

.XifinDocumentUpload-module__p-b-12___xGqHv {
  padding-bottom: 12px !important;
}

.XifinDocumentUpload-module__p-b-16___uOwGk {
  padding-bottom: 16px !important;
}

.XifinDocumentUpload-module__p-b-18___btdCO {
  padding-bottom: 18px !important;
}

.XifinDocumentUpload-module__p-b-20___s52BX {
  padding-bottom: 20px !important;
}

.XifinDocumentUpload-module__p-b-25___p25o0 {
  padding-bottom: 25px !important;
}

.XifinDocumentUpload-module__p-b-30___PUVaB {
  padding-bottom: 30px !important;
}

.XifinDocumentUpload-module__p-b-50___GyfhS {
  padding-bottom: 50px !important;
}

.XifinDocumentUpload-module__p-t-0___zu3Uj {
  padding-top: 0 !important;
}

.XifinDocumentUpload-module__p-t-12___cwlj1 {
  padding-top: 12px !important;
}

.XifinDocumentUpload-module__p-t-16___M2SxD {
  padding-top: 16px !important;
}

.XifinDocumentUpload-module__p-t-18___SQEHM {
  padding-top: 18px !important;
}

.XifinDocumentUpload-module__p-t-20___M4q4i {
  padding-top: 20px !important;
}

.XifinDocumentUpload-module__p-t-30___m3YK3 {
  padding-top: 30px !important;
}

.XifinDocumentUpload-module__p-t-40___IMoX6 {
  padding-top: 40px !important;
}

.XifinDocumentUpload-module__p-t-50___azVat {
  padding-top: 50px !important;
}

.XifinDocumentUpload-module__p-l-20___FElC7 {
  padding-left: 20px !important;
}

.XifinDocumentUpload-module__p-l-30___LIodD {
  padding-left: 30px !important;
}

.XifinDocumentUpload-module__p-l-40____StrG {
  padding-left: 40px !important;
}

.XifinDocumentUpload-module__p-r-16___Lt_1y {
  padding-right: 16px !important;
}

.XifinDocumentUpload-module__p-r-20___Azdsw {
  padding-right: 20px !important;
}

.XifinDocumentUpload-module__p-r-30___qw5Ex {
  padding-right: 30px !important;
}

.XifinDocumentUpload-module__p-r-50___wFM10 {
  padding-right: 50px !important;
}

.XifinDocumentUpload-module__p-r-60___WR6Uf {
  padding-right: 60px !important;
}

.XifinDocumentUpload-module__m-b-1___GVdQs {
  margin-bottom: 1px !important;
}

.XifinDocumentUpload-module__m-b-2___a3C5T {
  margin-bottom: 2px !important;
}

.XifinDocumentUpload-module__m-b-6___hSAqv {
  margin-bottom: 6px !important;
}

.XifinDocumentUpload-module__m-b-8___IPTju {
  margin-bottom: 8px !important;
}

.XifinDocumentUpload-module__m-b-10___jGw4F {
  margin-bottom: 10px !important;
}

.XifinDocumentUpload-module__m-b-14___LyUyr {
  margin-bottom: 14px !important;
}

.XifinDocumentUpload-module__m-b-16___zYnbb {
  margin-bottom: 16px !important;
}

.XifinDocumentUpload-module__m-b-20___WEXkr {
  margin-bottom: 20px !important;
}

.XifinDocumentUpload-module__m-b-22___Vnrc7 {
  margin-bottom: 22px !important;
}

.XifinDocumentUpload-module__m-b-24___lx6CI {
  margin-bottom: 24px !important;
}

.XifinDocumentUpload-module__m-b-30___TUyx6 {
  margin-bottom: 30px !important;
}

.XifinDocumentUpload-module__m-b-32___Xvx0k {
  margin-bottom: 32px !important;
}

.XifinDocumentUpload-module__m-b-40___tmM6e {
  margin-bottom: 40px !important;
}

.XifinDocumentUpload-module__m-t-2___ur5J_ {
  margin-top: 2px !important;
}

.XifinDocumentUpload-module__m-t-3___jdTPW {
  margin-top: 3px !important;
}

.XifinDocumentUpload-module__m-t-4___AVgRa {
  margin-top: 4px !important;
}

.XifinDocumentUpload-module__m-t-5___isKrv {
  margin-top: 5px !important;
}

.XifinDocumentUpload-module__m-t-8___UGYL8 {
  margin-top: 8px !important;
}

.XifinDocumentUpload-module__m-t-10___fD0tr {
  margin-top: 10px !important;
}

.XifinDocumentUpload-module__m-t-15___yXcGS {
  margin-top: 15px !important;
}

.XifinDocumentUpload-module__m-t-16___YTRgd {
  margin-top: 16px !important;
}

.XifinDocumentUpload-module__m-t-20___AF89c {
  margin-top: 20px !important;
}

.XifinDocumentUpload-module__m-t-22___tBXcF {
  margin-top: 22px !important;
}

.XifinDocumentUpload-module__m-t-30___Q5Xoy {
  margin-top: 30px !important;
}

.XifinDocumentUpload-module__m-t-32___rEs0N {
  margin-top: 32px !important;
}

.XifinDocumentUpload-module__m-l-auto___CNc5W {
  margin-left: auto !important;
}

.XifinDocumentUpload-module__m-l-4___WokOv {
  margin-left: 4px !important;
}

.XifinDocumentUpload-module__m-l-5___t_RcE {
  margin-left: 5px !important;
}

.XifinDocumentUpload-module__m-l-6___o2Q3a {
  margin-left: 6px !important;
}

.XifinDocumentUpload-module__m-l-8___Q3jpk {
  margin-left: 8px !important;
}

.XifinDocumentUpload-module__m-l-10___L8vIf {
  margin-left: 10px !important;
}

.XifinDocumentUpload-module__m-l-16___nF_r4 {
  margin-left: 16px !important;
}

.XifinDocumentUpload-module__m-l-20___DAJSg {
  margin-left: 20px !important;
}

.XifinDocumentUpload-module__m-l-24___NvnZJ {
  margin-left: 24px !important;
}

.XifinDocumentUpload-module__m-l-30___VZepR {
  margin-left: 30px !important;
}

.XifinDocumentUpload-module__m-l-35___W6vQs {
  margin-left: 35px !important;
}

.XifinDocumentUpload-module__m-l-40___xH5aC {
  margin-left: 40px !important;
}

.XifinDocumentUpload-module__m-r-8___bHJ6t {
  margin-right: 8px !important;
}

.XifinDocumentUpload-module__m-r-10___sf5QL {
  margin-right: 10px !important;
}

.XifinDocumentUpload-module__m-r-16___KJWMo {
  margin-right: 16px !important;
}

.XifinDocumentUpload-module__m-r-20___sdeJs {
  margin-right: 20px !important;
}

.XifinDocumentUpload-module__m-r-24___oHTun {
  margin-right: 24px !important;
}

.XifinDocumentUpload-module__m-r-30___J7o8m {
  margin-right: 30px !important;
}

.XifinDocumentUpload-module__m-r-40___YerSZ {
  margin-right: 40px !important;
}

.XifinDocumentUpload-module__border-r-3___kUTAc {
  border-radius: 3px !important;
}

.XifinDocumentUpload-module__border-r-4___ss61H {
  border-radius: 4px !important;
}

.XifinDocumentUpload-module__border-r-6___C2EZa {
  border-radius: 6px !important;
}

.XifinDocumentUpload-module__border-r-10___INg5x {
  border-radius: 10px !important;
}

.XifinDocumentUpload-module__border-r-12___G3ZA0 {
  border-radius: 12px !important;
}

.XifinDocumentUpload-module__border-r-16___BgO5q {
  border-radius: 16px !important;
}

.XifinDocumentUpload-module__border-r-50___ZjP90 {
  border-radius: 50% !important;
}

.XifinDocumentUpload-module__primary-border___f7bXs {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.XifinDocumentUpload-module__primary-border-b___tzs1t {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.XifinDocumentUpload-module__primary-border-t___BJxyG {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.XifinDocumentUpload-module__primary-border-l___zJhyD {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.XifinDocumentUpload-module__primary-border-r___DiVTa {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.XifinDocumentUpload-module__secondary-border___DT4Vd {
  border: 1px solid #637768;
}

.XifinDocumentUpload-module__secondary-border-b___eiUID {
  border-bottom: 1px solid #637768;
}

.XifinDocumentUpload-module__secondary-border-t___t0hMI {
  border-top: 1px solid #637768;
}

.XifinDocumentUpload-module__secondary-border-l___HnsMT {
  border-left: 1px solid #637768;
}

.XifinDocumentUpload-module__secondary-border-r___pOUPo {
  border-right: 1px solid #637768;
}

.XifinDocumentUpload-module__gap-0___Jo2Li {
  gap: 0 !important;
}

.XifinDocumentUpload-module__gap-2___GrTrE {
  gap: 2px !important;
}

.XifinDocumentUpload-module__gap-4___x5dWE {
  gap: 4px !important;
}

.XifinDocumentUpload-module__gap-5___jv_ai {
  gap: 5px !important;
}

.XifinDocumentUpload-module__gap-6___elq9E {
  gap: 6px !important;
}

.XifinDocumentUpload-module__gap-8___XCQLI {
  gap: 8px !important;
}

.XifinDocumentUpload-module__gap-10___VGEwj {
  gap: 10px !important;
}

.XifinDocumentUpload-module__gap-12___gyCaS {
  gap: 12px !important;
}

.XifinDocumentUpload-module__gap-14___LHDEx {
  gap: 14px !important;
}

.XifinDocumentUpload-module__gap-16___rBow6 {
  gap: 16px !important;
}

.XifinDocumentUpload-module__gap-18___y0dwg {
  gap: 18px !important;
}

.XifinDocumentUpload-module__gap-20___OO95N {
  gap: 20px !important;
}

.XifinDocumentUpload-module__gap-24___PN2ry {
  gap: 24px !important;
}

.XifinDocumentUpload-module__gap-26___JZpFQ {
  gap: 26px !important;
}

.XifinDocumentUpload-module__gap-30___nzR4d {
  gap: 30px !important;
}

.XifinDocumentUpload-module__gap-32___YRrEu {
  gap: 32px !important;
}

.XifinDocumentUpload-module__gap-40___pMiS1 {
  gap: 40px !important;
}

.XifinDocumentUpload-module__gap-50___QhWHX {
  gap: 50px !important;
}

.XifinDocumentUpload-module__flex-1___cGACW {
  flex: 1;
}

.XifinDocumentUpload-module__flex-none___p7KPP {
  flex: none !important;
}

.XifinDocumentUpload-module__flex-column___w7bN_ {
  display: flex;
  flex-direction: column !important;
}

.XifinDocumentUpload-module__flex-row___wnx86 {
  display: flex;
  flex-direction: row !important;
}

.XifinDocumentUpload-module__vertically-centered___vp_Ln {
  display: flex;
  align-items: center !important;
}

.XifinDocumentUpload-module__horizontally-centered___dDgYN {
  display: flex;
  justify-content: center !important;
}

.XifinDocumentUpload-module__horizontally-end___mxBuH {
  display: flex;
  justify-content: end !important;
}

.XifinDocumentUpload-module__vertically-start___ByT7V {
  display: flex;
  align-items: start !important;
}

.XifinDocumentUpload-module__space-between___RqWSy {
  display: flex;
  justify-content: space-between !important;
}

.XifinDocumentUpload-module__flex-wrap___O2VBv {
  flex-wrap: wrap !important;
}

.XifinDocumentUpload-module__height-100___fPxe2 {
  height: 100%;
}

.XifinDocumentUpload-module__width-50___cj2md {
  width: 50% !important;
}

.XifinDocumentUpload-module__width-100___DinpN {
  width: 100%;
}

.XifinDocumentUpload-module__cursor-pointer___cKmHJ {
  cursor: pointer;
}

.XifinDocumentUpload-module__cursor-not-allowed___wZKz4 {
  cursor: not-allowed !important;
}

.XifinDocumentUpload-module__absolute-centered___Jee76 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.XifinDocumentUpload-module__absolute___PcwxY {
  position: absolute;
}

.XifinDocumentUpload-module__relative___EbNuY {
  position: relative;
}

.XifinDocumentUpload-module__fixed___CIazT {
  position: fixed;
}

.XifinDocumentUpload-module__visible___e8tyT {
  opacity: 1;
}

.XifinDocumentUpload-module__invisible___TWzDX {
  opacity: 0;
}

.XifinDocumentUpload-module__col-90___ZRFqH {
  width: 90% !important;
}

.XifinDocumentUpload-module__col-auto___lxXa4 {
  width: auto !important;
}

.XifinDocumentUpload-module__medical-tabs___wKtBj {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.XifinDocumentUpload-module__medical-table-new___L5uNt {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.XifinDocumentUpload-module__medical-table-new___L5uNt:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.XifinDocumentUpload-module__medical-table-new___L5uNt::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.XifinDocumentUpload-module__medical-table-new___L5uNt::-webkit-scrollbar-track {
  display: none;
}
.XifinDocumentUpload-module__medical-table-new___L5uNt.XifinDocumentUpload-module__no-pagination___x55QC {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.XifinDocumentUpload-module__medical-table-new___L5uNt.XifinDocumentUpload-module__no-pagination___x55QC:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.XifinDocumentUpload-module__medical-table-new___L5uNt.XifinDocumentUpload-module__no-pagination___x55QC::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.XifinDocumentUpload-module__medical-table-new___L5uNt.XifinDocumentUpload-module__no-pagination___x55QC::-webkit-scrollbar-track {
  display: none;
}

.XifinDocumentUpload-module__medical-table-empty___wPYRA {
  padding: 14px 40px !important;
}

.XifinDocumentUpload-module__icon-btn____mG37 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.XifinDocumentUpload-module__search-icon___2ava5 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.XifinDocumentUpload-module__disable-select___ammI4 {
  user-select: none;
}

.XifinDocumentUpload-module__break-word___mvrlm {
  word-break: break-word;
}

.XifinDocumentUpload-module__popup-clear-btn___fWP_z {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.XifinDocumentUpload-module__scroll-m-b-20___RDRLF {
  scroll-margin-bottom: 20px;
}

.XifinDocumentUpload-module__section___bOkao {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 36px;
  max-width: 620px;
}

.XifinDocumentUpload-module__title___Co3EU {
  color: #375844;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.XifinDocumentUpload-module__instructions___EDy2x {
  color: #859989;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  margin: 0;
}
.XifinDocumentUpload-module__instructions___EDy2x a {
  color: #375844;
  font-weight: 600;
  text-decoration: underline;
}

.XifinDocumentUpload-module__controls___lvtAX {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.XifinDocumentUpload-module__controls___lvtAX button {
  min-width: 108px;
}

.XifinDocumentUpload-module__fileLabel___BVboZ {
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 600;
  gap: 8px;
  width: 100%;
}

.XifinDocumentUpload-module__status___ar4jG,
.XifinDocumentUpload-module__error___jfHVl,
.XifinDocumentUpload-module__success___GldJo {
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.4;
  margin: 0;
  padding: 12px 14px;
}

.XifinDocumentUpload-module__status___ar4jG {
  background: rgba(55, 88, 68, 0.5019607843);
  color: #375844;
}

.XifinDocumentUpload-module__error___jfHVl {
  background: #fcebea;
  color: #a82c27;
}

.XifinDocumentUpload-module__success___GldJo {
  background: #e7f4ec;
  border: 1px solid #a8eccc;
  color: #375844;
}

@media (max-width: 640px) {
  .XifinDocumentUpload-module__controls___lvtAX {
    align-items: stretch;
    flex-direction: column;
  }
  .XifinDocumentUpload-module__controls___lvtAX button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/Reports/XifinDocumentUpload/XifinDocumentUpload.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AA8pBF;;AA3pBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AA8pBF;AA5pBE;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;AA8pBJ;;AA1pBA;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AA6pBF;AA3pBE;EACE,gBAAA;AA6pBJ;;AAzpBA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,QAAA;EACA,WAAA;AA4pBF;;AAzpBA;;;EAGE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;AA4pBF;;AAzpBA;EACE,0CAAA;EACA,cAAA;AA4pBF;;AAzpBA;EACE,mBAAA;EACA,cAAA;AA4pBF;;AAzpBA;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AA4pBF;;AAzpBA;EACE;IACE,oBAAA;IACA,sBAAA;EA4pBF;EAzpBA;IACE,WAAA;EA2pBF;AACF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 36px;\n  max-width: 620px;\n}\n\n.title {\n  color: get-color(greenNew, dark);\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0;\n}\n\n.instructions {\n  color: get-color(greenNew, medium);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n  margin: 0;\n\n  a {\n    color: get-color(greenNew, dark);\n    font-weight: 600;\n    text-decoration: underline;\n  }\n}\n\n.controls {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n\n  button {\n    min-width: 108px;\n  }\n}\n\n.fileLabel {\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n  font-weight: 600;\n  gap: 8px;\n  width: 100%;\n}\n\n.status,\n.error,\n.success {\n  border-radius: 6px;\n  font-size: 14px;\n  line-height: 1.4;\n  margin: 0;\n  padding: 12px 14px;\n}\n\n.status {\n  background: get-color(greenNew, lightest);\n  color: get-color(greenNew, dark);\n}\n\n.error {\n  background: #fcebea;\n  color: #a82c27;\n}\n\n.success {\n  background: #e7f4ec;\n  border: 1px solid get-color(greenNew, light);\n  color: get-color(greenNew, dark);\n}\n\n@media (max-width: 640px) {\n  .controls {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .controls button {\n    width: 100%;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `XifinDocumentUpload-module__font-s-10___NXsrk`,
	"fontS12": `XifinDocumentUpload-module__font-s-12___mZhgs`,
	"fontS13": `XifinDocumentUpload-module__font-s-13___OBKMh`,
	"fontS14": `XifinDocumentUpload-module__font-s-14___ueU7N`,
	"fontS15": `XifinDocumentUpload-module__font-s-15___vzhrk`,
	"fontS16": `XifinDocumentUpload-module__font-s-16___zQdke`,
	"fontS18": `XifinDocumentUpload-module__font-s-18___fINEU`,
	"fontS20": `XifinDocumentUpload-module__font-s-20___tu3qj`,
	"fontS22": `XifinDocumentUpload-module__font-s-22___LqndE`,
	"fontS28": `XifinDocumentUpload-module__font-s-28___aiuKn`,
	"fontW400": `XifinDocumentUpload-module__font-w-400___morsZ`,
	"fontW500": `XifinDocumentUpload-module__font-w-500___dfIsp`,
	"fontW600": `XifinDocumentUpload-module__font-w-600___WLgcv`,
	"fontW700": `XifinDocumentUpload-module__font-w-700___IMg0K`,
	"p5": `XifinDocumentUpload-module__p-5___e1oGw`,
	"p12": `XifinDocumentUpload-module__p-12___kHqtY`,
	"p16": `XifinDocumentUpload-module__p-16___vasjI`,
	"p30": `XifinDocumentUpload-module__p-30___JuV1f`,
	"pB0": `XifinDocumentUpload-module__p-b-0___BHN1E`,
	"pB5": `XifinDocumentUpload-module__p-b-5___HJod2`,
	"pB10": `XifinDocumentUpload-module__p-b-10___RwDoL`,
	"pB12": `XifinDocumentUpload-module__p-b-12___xGqHv`,
	"pB16": `XifinDocumentUpload-module__p-b-16___uOwGk`,
	"pB18": `XifinDocumentUpload-module__p-b-18___btdCO`,
	"pB20": `XifinDocumentUpload-module__p-b-20___s52BX`,
	"pB25": `XifinDocumentUpload-module__p-b-25___p25o0`,
	"pB30": `XifinDocumentUpload-module__p-b-30___PUVaB`,
	"pB50": `XifinDocumentUpload-module__p-b-50___GyfhS`,
	"pT0": `XifinDocumentUpload-module__p-t-0___zu3Uj`,
	"pT12": `XifinDocumentUpload-module__p-t-12___cwlj1`,
	"pT16": `XifinDocumentUpload-module__p-t-16___M2SxD`,
	"pT18": `XifinDocumentUpload-module__p-t-18___SQEHM`,
	"pT20": `XifinDocumentUpload-module__p-t-20___M4q4i`,
	"pT30": `XifinDocumentUpload-module__p-t-30___m3YK3`,
	"pT40": `XifinDocumentUpload-module__p-t-40___IMoX6`,
	"pT50": `XifinDocumentUpload-module__p-t-50___azVat`,
	"pL20": `XifinDocumentUpload-module__p-l-20___FElC7`,
	"pL30": `XifinDocumentUpload-module__p-l-30___LIodD`,
	"pL40": `XifinDocumentUpload-module__p-l-40____StrG`,
	"pR16": `XifinDocumentUpload-module__p-r-16___Lt_1y`,
	"pR20": `XifinDocumentUpload-module__p-r-20___Azdsw`,
	"pR30": `XifinDocumentUpload-module__p-r-30___qw5Ex`,
	"pR50": `XifinDocumentUpload-module__p-r-50___wFM10`,
	"pR60": `XifinDocumentUpload-module__p-r-60___WR6Uf`,
	"mB1": `XifinDocumentUpload-module__m-b-1___GVdQs`,
	"mB2": `XifinDocumentUpload-module__m-b-2___a3C5T`,
	"mB6": `XifinDocumentUpload-module__m-b-6___hSAqv`,
	"mB8": `XifinDocumentUpload-module__m-b-8___IPTju`,
	"mB10": `XifinDocumentUpload-module__m-b-10___jGw4F`,
	"mB14": `XifinDocumentUpload-module__m-b-14___LyUyr`,
	"mB16": `XifinDocumentUpload-module__m-b-16___zYnbb`,
	"mB20": `XifinDocumentUpload-module__m-b-20___WEXkr`,
	"mB22": `XifinDocumentUpload-module__m-b-22___Vnrc7`,
	"mB24": `XifinDocumentUpload-module__m-b-24___lx6CI`,
	"mB30": `XifinDocumentUpload-module__m-b-30___TUyx6`,
	"mB32": `XifinDocumentUpload-module__m-b-32___Xvx0k`,
	"mB40": `XifinDocumentUpload-module__m-b-40___tmM6e`,
	"mT2": `XifinDocumentUpload-module__m-t-2___ur5J_`,
	"mT3": `XifinDocumentUpload-module__m-t-3___jdTPW`,
	"mT4": `XifinDocumentUpload-module__m-t-4___AVgRa`,
	"mT5": `XifinDocumentUpload-module__m-t-5___isKrv`,
	"mT8": `XifinDocumentUpload-module__m-t-8___UGYL8`,
	"mT10": `XifinDocumentUpload-module__m-t-10___fD0tr`,
	"mT15": `XifinDocumentUpload-module__m-t-15___yXcGS`,
	"mT16": `XifinDocumentUpload-module__m-t-16___YTRgd`,
	"mT20": `XifinDocumentUpload-module__m-t-20___AF89c`,
	"mT22": `XifinDocumentUpload-module__m-t-22___tBXcF`,
	"mT30": `XifinDocumentUpload-module__m-t-30___Q5Xoy`,
	"mT32": `XifinDocumentUpload-module__m-t-32___rEs0N`,
	"mLAuto": `XifinDocumentUpload-module__m-l-auto___CNc5W`,
	"mL4": `XifinDocumentUpload-module__m-l-4___WokOv`,
	"mL5": `XifinDocumentUpload-module__m-l-5___t_RcE`,
	"mL6": `XifinDocumentUpload-module__m-l-6___o2Q3a`,
	"mL8": `XifinDocumentUpload-module__m-l-8___Q3jpk`,
	"mL10": `XifinDocumentUpload-module__m-l-10___L8vIf`,
	"mL16": `XifinDocumentUpload-module__m-l-16___nF_r4`,
	"mL20": `XifinDocumentUpload-module__m-l-20___DAJSg`,
	"mL24": `XifinDocumentUpload-module__m-l-24___NvnZJ`,
	"mL30": `XifinDocumentUpload-module__m-l-30___VZepR`,
	"mL35": `XifinDocumentUpload-module__m-l-35___W6vQs`,
	"mL40": `XifinDocumentUpload-module__m-l-40___xH5aC`,
	"mR8": `XifinDocumentUpload-module__m-r-8___bHJ6t`,
	"mR10": `XifinDocumentUpload-module__m-r-10___sf5QL`,
	"mR16": `XifinDocumentUpload-module__m-r-16___KJWMo`,
	"mR20": `XifinDocumentUpload-module__m-r-20___sdeJs`,
	"mR24": `XifinDocumentUpload-module__m-r-24___oHTun`,
	"mR30": `XifinDocumentUpload-module__m-r-30___J7o8m`,
	"mR40": `XifinDocumentUpload-module__m-r-40___YerSZ`,
	"borderR3": `XifinDocumentUpload-module__border-r-3___kUTAc`,
	"borderR4": `XifinDocumentUpload-module__border-r-4___ss61H`,
	"borderR6": `XifinDocumentUpload-module__border-r-6___C2EZa`,
	"borderR10": `XifinDocumentUpload-module__border-r-10___INg5x`,
	"borderR12": `XifinDocumentUpload-module__border-r-12___G3ZA0`,
	"borderR16": `XifinDocumentUpload-module__border-r-16___BgO5q`,
	"borderR50": `XifinDocumentUpload-module__border-r-50___ZjP90`,
	"primaryBorder": `XifinDocumentUpload-module__primary-border___f7bXs`,
	"primaryBorderB": `XifinDocumentUpload-module__primary-border-b___tzs1t`,
	"primaryBorderT": `XifinDocumentUpload-module__primary-border-t___BJxyG`,
	"primaryBorderL": `XifinDocumentUpload-module__primary-border-l___zJhyD`,
	"primaryBorderR": `XifinDocumentUpload-module__primary-border-r___DiVTa`,
	"secondaryBorder": `XifinDocumentUpload-module__secondary-border___DT4Vd`,
	"secondaryBorderB": `XifinDocumentUpload-module__secondary-border-b___eiUID`,
	"secondaryBorderT": `XifinDocumentUpload-module__secondary-border-t___t0hMI`,
	"secondaryBorderL": `XifinDocumentUpload-module__secondary-border-l___HnsMT`,
	"secondaryBorderR": `XifinDocumentUpload-module__secondary-border-r___pOUPo`,
	"gap0": `XifinDocumentUpload-module__gap-0___Jo2Li`,
	"gap2": `XifinDocumentUpload-module__gap-2___GrTrE`,
	"gap4": `XifinDocumentUpload-module__gap-4___x5dWE`,
	"gap5": `XifinDocumentUpload-module__gap-5___jv_ai`,
	"gap6": `XifinDocumentUpload-module__gap-6___elq9E`,
	"gap8": `XifinDocumentUpload-module__gap-8___XCQLI`,
	"gap10": `XifinDocumentUpload-module__gap-10___VGEwj`,
	"gap12": `XifinDocumentUpload-module__gap-12___gyCaS`,
	"gap14": `XifinDocumentUpload-module__gap-14___LHDEx`,
	"gap16": `XifinDocumentUpload-module__gap-16___rBow6`,
	"gap18": `XifinDocumentUpload-module__gap-18___y0dwg`,
	"gap20": `XifinDocumentUpload-module__gap-20___OO95N`,
	"gap24": `XifinDocumentUpload-module__gap-24___PN2ry`,
	"gap26": `XifinDocumentUpload-module__gap-26___JZpFQ`,
	"gap30": `XifinDocumentUpload-module__gap-30___nzR4d`,
	"gap32": `XifinDocumentUpload-module__gap-32___YRrEu`,
	"gap40": `XifinDocumentUpload-module__gap-40___pMiS1`,
	"gap50": `XifinDocumentUpload-module__gap-50___QhWHX`,
	"flex1": `XifinDocumentUpload-module__flex-1___cGACW`,
	"flexNone": `XifinDocumentUpload-module__flex-none___p7KPP`,
	"flexColumn": `XifinDocumentUpload-module__flex-column___w7bN_`,
	"flexRow": `XifinDocumentUpload-module__flex-row___wnx86`,
	"verticallyCentered": `XifinDocumentUpload-module__vertically-centered___vp_Ln`,
	"horizontallyCentered": `XifinDocumentUpload-module__horizontally-centered___dDgYN`,
	"horizontallyEnd": `XifinDocumentUpload-module__horizontally-end___mxBuH`,
	"verticallyStart": `XifinDocumentUpload-module__vertically-start___ByT7V`,
	"spaceBetween": `XifinDocumentUpload-module__space-between___RqWSy`,
	"flexWrap": `XifinDocumentUpload-module__flex-wrap___O2VBv`,
	"height100": `XifinDocumentUpload-module__height-100___fPxe2`,
	"width50": `XifinDocumentUpload-module__width-50___cj2md`,
	"width100": `XifinDocumentUpload-module__width-100___DinpN`,
	"cursorPointer": `XifinDocumentUpload-module__cursor-pointer___cKmHJ`,
	"cursorNotAllowed": `XifinDocumentUpload-module__cursor-not-allowed___wZKz4`,
	"absoluteCentered": `XifinDocumentUpload-module__absolute-centered___Jee76`,
	"absolute": `XifinDocumentUpload-module__absolute___PcwxY`,
	"relative": `XifinDocumentUpload-module__relative___EbNuY`,
	"fixed": `XifinDocumentUpload-module__fixed___CIazT`,
	"visible": `XifinDocumentUpload-module__visible___e8tyT`,
	"invisible": `XifinDocumentUpload-module__invisible___TWzDX`,
	"col90": `XifinDocumentUpload-module__col-90___ZRFqH`,
	"colAuto": `XifinDocumentUpload-module__col-auto___lxXa4`,
	"medicalTabs": `XifinDocumentUpload-module__medical-tabs___wKtBj`,
	"medicalTableNew": `XifinDocumentUpload-module__medical-table-new___L5uNt`,
	"noPagination": `XifinDocumentUpload-module__no-pagination___x55QC`,
	"medicalTableEmpty": `XifinDocumentUpload-module__medical-table-empty___wPYRA`,
	"iconBtn": `XifinDocumentUpload-module__icon-btn____mG37`,
	"searchIcon": `XifinDocumentUpload-module__search-icon___2ava5`,
	"disableSelect": `XifinDocumentUpload-module__disable-select___ammI4`,
	"breakWord": `XifinDocumentUpload-module__break-word___mvrlm`,
	"popupClearBtn": `XifinDocumentUpload-module__popup-clear-btn___fWP_z`,
	"scrollMB20": `XifinDocumentUpload-module__scroll-m-b-20___RDRLF`,
	"section": `XifinDocumentUpload-module__section___bOkao`,
	"title": `XifinDocumentUpload-module__title___Co3EU`,
	"instructions": `XifinDocumentUpload-module__instructions___EDy2x`,
	"controls": `XifinDocumentUpload-module__controls___lvtAX`,
	"fileLabel": `XifinDocumentUpload-module__fileLabel___BVboZ`,
	"status": `XifinDocumentUpload-module__status___ar4jG`,
	"error": `XifinDocumentUpload-module__error___jfHVl`,
	"success": `XifinDocumentUpload-module__success___GldJo`
};
module.exports = ___CSS_LOADER_EXPORT___;
